export default function replacePlaceholders(tmntString, valuesToFillIn = {}) {
  if (!valuesToFillIn || Object.keys(valuesToFillIn).length === 0) {
    return tmntString;
  }
  return tmntString
    .replace(/{([\w-]+?)}/g, (match, capture) => valuesToFillIn[capture] || match);
}
